import { motion } from 'framer-motion';
import { FloatingParticles } from '@/components/focus/FloatingParticles';

export function OnboardingBackground() {
  return (
    <div className="fixed inset-0 bg-background overflow-hidden">
      {/* Floating ambient particles */}
      <FloatingParticles count={8} variant="focus" />
      
      {/* Large centered breathing gradient orb */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <motion.div
          className="w-[600px] h-[600px] rounded-full opacity-20"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.15, 0.25, 0.15],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            background: 'radial-gradient(circle, hsl(var(--primary) / 0.4) 0%, transparent 70%)',
            filter: 'blur(80px)',
          }}
        />
      </div>
      
      {/* Subtle gradient overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, hsl(var(--background)) 80%)',
        }}
      />
    </div>
  );
}
